// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasObjectsAlignRight: CreateIconOptions = {
  "displayName": "FASObjectsAlignRight",
  "viewBox": "0, 0, 512, 512",
  "d": "M512 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 64c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 224c-26.5 0-48-21.5-48-48l0-64C0 85.5 21.5 64 48 64l288 0zm0 224c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l160 0z"
};
